/**
 * Before/after values for rows changed by an accounting fix.
 */
export default function AccountingChangeRecordsTable({
  records = [],
  total = 0,
  truncated = false,
  source = null,
}) {
  if (!records.length && total === 0) {
    return (
      <p className="small text-muted mb-0">
        No per-row before/after detail was saved for this fix.
        {source === 'none' && ' Older fixes may only show row counts in the activity log.'}
      </p>
    );
  }

  const showIssue = records.some((row) => row.issue);
  const showFormula = records.some((row) => row.formula);
  const showCreatedBy = records.some((row) => row.created_by_name);
  const showUpdatedBy = records.some((row) => row.updated_by_name);

  return (
    <>
      <p className="small text-muted mb-2">
        Showing {records.length} of {total || records.length} affected record(s).
        {truncated && ' Full list is capped at 20 rows in preview (200 on apply).'}
        {source && source !== 'none' && (
          <span className="d-block mt-1">
            Saved on fix case
            {source === 'apply_result' && ' (apply snapshot)'}
            {source === 'wac_audit' && ' (from WAC audit trail)'}
            {source === 'preview' && ' (preview — no changes applied yet)'}
            {source === 'preview_payload' && ' (from preview — apply snapshot was not stored)'}
            .
          </span>
        )}
      </p>
      <div className="table-responsive">
        <table className="table table-sm admin-pump-table accounting-change-records-table">
          <thead>
            <tr>
              <th>Record</th>
              <th>Field</th>
              {showIssue && <th>Where the error is</th>}
              <th>Before</th>
              <th>After</th>
              {showFormula && <th>Formula / fix</th>}
              {showCreatedBy && <th>Created by</th>}
              {showUpdatedBy && <th>Updated by</th>}
              <th>Detail</th>
            </tr>
          </thead>
          <tbody>
            {records.map((row, index) => (
              <tr key={`${row.label}-${row.field}-${index}`}>
                <td className="small">{row.label || '—'}</td>
                <td className="small">{row.field || '—'}</td>
                {showIssue && (
                  <td className="small text-muted">{row.issue || '—'}</td>
                )}
                <td className="small accounting-change-old">{row.old_value ?? '—'}</td>
                <td className="small accounting-change-new">{row.new_value ?? '—'}</td>
                {showFormula && (
                  <td className="small">{row.formula || '—'}</td>
                )}
                {showCreatedBy && (
                  <td className="small text-muted">{row.created_by_name || '—'}</td>
                )}
                {showUpdatedBy && (
                  <td className="small text-muted">{row.updated_by_name || '—'}</td>
                )}
                <td className="small text-muted">{row.detail || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
